import type { VNode } from "preact";

interface HeroSectionProps {
  children?: VNode | VNode[];
  className?: string;
  /** Background image URL (e.g. from import) */
  backgroundImage?: string;
  /** Section id for scroll-to-hash when returning from App Clip */
  id?: string;
  /** Additional inline styles for the section */
  style?: Record<string, string | number>;
}

export function HeroSection({
  children,
  className = "",
  backgroundImage,
  id,
  style = {},
}: HeroSectionProps): VNode {
  const sectionStyle = backgroundImage ? undefined : style;

  return (
    <section
      id={id}
      className={`w-full sm:px-8 2xl:px-12 px-5 flex flex-col items-start flex-shrink-0 h-[calc(100dvh-96px)] sm:h-[calc(100dvh-112px)] 2xl:h-[calc(100dvh-140px)] relative overflow-hidden bg-[#1C2429] ${className}`}
      style={Object.keys(sectionStyle || {}).length > 0 ? sectionStyle : undefined}
    >
      {backgroundImage && (
        <>
          <img
            src={backgroundImage}
            alt=""
            fetchPriority="high"
            className="absolute inset-0 w-full h-full object-cover object-center z-0"
          />
          <div className="relative z-10 flex flex-col flex-1 w-full">{children}</div>
        </>
      )}
      {!backgroundImage && children}
    </section>
  );
}
